export const EASE = "cubic-bezier(0.2, 0, 0, 1)";

export const FIELD_OPEN_MS = 280;
export const ICON_CROSSFADE_MS = 120;
export const ICON_CROSSFADE_DELAY_MS = 60;

export const INDICATOR_ENTER_DELAY_MS = 120;
export const INDICATOR_ENTER_MS = FIELD_OPEN_MS - INDICATOR_ENTER_DELAY_MS;

export const FIELD_GROW_MS = 180;
export const LINE_FADE_MS = 120;

export const INDICATOR_LOUDNESS_MS = 90;
export const INDICATOR_SETTLE_MS = 240;
export const QUIET_BEFORE_SETTLE_MS = 400;

export const BUTTON_COLOR_MS = 200;
export const INDICATOR_EXIT_MS = 140;

export const FIELD_COLLAPSE_MS = 220;

export const PRESS_MS = 120;
export const PRESS_TRANSITION = `transform ${PRESS_MS}ms ease, box-shadow ${PRESS_MS}ms ease`;

/**
 * Motion here decorates state changes that have already happened, so reduced motion drops a
 * transition rather than shortening it.
 */
export const REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";

export const prefersReducedMotion = (): boolean => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
